<div class="pattern top-pattern">
  <div class="top-left"></div>
  <div class="top-right"></div>
  <div class="bottom-left"></div>
  <div class="bottom-right"></div>
</div>
<div class="pattern bottom-pattern">
  <div class="top-left"></div>
  <div class="top-center"></div>
  <div class="top-right"></div>
  <div class="middle-left"></div>
  <div class="middle-center"></div>
  <div class="middle-right"></div>
  <div class="bottom-left"></div>
  <div class="bottom-center"></div>
  <div class="bottom-right"></div>
</div>
